import { useMemo } from 'react';
import { useProductPricingApi } from 'app/common/hooks';
import { determineProductOrVariantPricing } from 'app/product/utils/PricingUtils';

function useDetermineActiveOptionPricing(product, activeOption) {
  const productArray = useMemo(() => (product ? [product] : []), [product]);
  const priceInfoResponse = useProductPricingApi(productArray);

  return useMemo(() => {
    let productPricing = {};
    let activeOptionPricing = {};

    const productId = product?.id;
    const priceData = productId ? priceInfoResponse?.[productId] : null;

    if (priceData) {
      const { priceInfo } = priceData;
      productPricing = determineProductOrVariantPricing(product, priceInfo);
      const activeOptionPriceInfo = activeOption?.priceInfo ?? priceInfo;
      activeOptionPricing = determineProductOrVariantPricing(
        activeOption,
        activeOptionPriceInfo
      );
    }

    return (
      (activeOptionPricing && Object.keys(activeOptionPricing).length > 0
        ? activeOptionPricing
        : productPricing) || {}
    );
  }, [product, activeOption, priceInfoResponse]);
}

export default useDetermineActiveOptionPricing;
